import {
  ACCESS_TEMPLATE_LIST,
  ACCESS_TEMPLATE_LIST_FAIL,
  ACCESS_TEMPLATE_LIST_SUCCESS,
  ADD_ACCESS_TEMPLATE,
  ADD_ACCESS_TEMPLATE_FAIL,
  ADD_ACCESS_TEMPLATE_SUCCESS,
  ASSIGN_ACCESS,
  ASSIGN_ACCESS_FAIL,
  ASSIGN_ACCESS_SUCCESS,
  GET_ACCESS_TEMPLATE,
  GET_ACCESS_TEMPLATE_FAIL,
  GET_ACCESS_TEMPLATE_SUCCESS,
  UPDATE_ACCESS_TEMPLATE,
  UPDATE_ACCESS_TEMPLATE_FAIL,
  UPDATE_ACCESS_TEMPLATE_SUCCESS,
} from "./actionTypes";

export const getAccessTemplate = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ACCESS_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const getAccessTemplateSuccess = data => ({
  type: GET_ACCESS_TEMPLATE_SUCCESS,
  payload: data,
});

export const getAccessTemplateFail = data => ({
  type: GET_ACCESS_TEMPLATE_FAIL,
  payload: data,
});

export const assignAccess = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ASSIGN_ACCESS,
  payload: { data, onSuccess, onError },
});

export const assignAccessSuccess = data => ({
  type: ASSIGN_ACCESS_SUCCESS,
  payload: data,
});

export const assignAccessFail = data => ({
  type: ASSIGN_ACCESS_FAIL,
  payload: data,
});

export const accessTemplateList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ACCESS_TEMPLATE_LIST,
  payload: { data, onSuccess, onError },
});

export const accessTemplateListSuccess = data => ({
  type: ACCESS_TEMPLATE_LIST_SUCCESS,
  payload: data,
});

export const accessTemplateListFail = data => ({
  type: ACCESS_TEMPLATE_LIST_FAIL,
  payload: data,
});

export const addAccessTemplate = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_ACCESS_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const addAccessTemplateSuccess = data => ({
  type: ADD_ACCESS_TEMPLATE_SUCCESS,
  payload: data,
});

export const addAccessTemplateFail = data => ({
  type: ADD_ACCESS_TEMPLATE_FAIL,
  payload: data,
});

export const updateAccessTemplate = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_ACCESS_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const updateAccessTemplateSuccess = data => ({
  type: UPDATE_ACCESS_TEMPLATE_SUCCESS,
  payload: data,
});

export const updateAccessTemplateFail = data => ({
  type: UPDATE_ACCESS_TEMPLATE_FAIL,
  payload: data,
});
